import React from 'react';
import { Assignment } from 'types/assignment';
import { getAssignmentDisplayData } from './utils';
import { IsMobile } from 'types/mobile';
import { DesktopView } from './components/desktopView';
import { MobileView } from './components/mobileView';

type Props = IsMobile & { assignment: Assignment };

export const AssignmentPresentation: React.FC<Props> = ({ assignment, isMobileScreen }) => {
  const assignmentDisplayData = getAssignmentDisplayData(assignment);

  return isMobileScreen ? (
    <MobileView assignment={assignmentDisplayData} />
  ) : (
    <DesktopView assignment={assignmentDisplayData} />
  );
};
